import moment from 'moment'
import _ from 'lodash'
moment.locale('en')

function roundedToFixed (_float, _digits) {
  var rounder = Math.pow(10, _digits)
  return Math.round(_float * rounder) / rounder
}

export function getMonthArray () {
  return moment.monthsShort()
}

export function getYearArray () {
  const startYear = new Date().getFullYear()
  return _.range(startYear, 1900, -1)
}

export function diffNowDays (ts) {
  return moment().diff(ts, 'days')
}

export function differenceYears (startYear, endYear, startMonth, endMonth) {
  const months = getMonthArray()
  startYear = parseInt(startYear)
  if (!startMonth) {
    startMonth = 1
  } else {
    if (isNaN(startMonth)) {
      startMonth = months.indexOf(startMonth)
    }
  }
  if (!endYear) {
    endYear = moment().year()
    endMonth = moment().month()
  } else {
    endYear = parseInt(endYear)
  }

  if (!endMonth) {
    endMonth = 1
  } else {
    if (isNaN(endMonth)) {
      endMonth = months.indexOf(endMonth)
    }
  }
  var a = moment([startYear, startMonth, 1])
  var b = moment([endYear, endMonth, 1])
  var years = b.diff(a, 'year')
  return years
}

export function differenceYearsMonths (startYear, endYear, startMonth, endMonth) {
  const months = getMonthArray()
  startYear = parseInt(startYear)
  if (!startMonth) {
    startMonth = 1
  } else {
    if (isNaN(startMonth)) {
      startMonth = months.indexOf(startMonth)
    }
  }
  if (!endYear) {
    endYear = moment().year()
    endMonth = moment().month()
  } else {
    endYear = parseInt(endYear)
  }

  if (!endMonth) {
    endMonth = 1
  } else {
    if (isNaN(endMonth)) {
      endMonth = months.indexOf(endMonth)
    }
  }

  var a = moment([startYear, startMonth, 1])
  var b = moment([endYear, endMonth, 1])
  var years = b.diff(a, 'year')
  var monthDiff = b.diff(a, 'month')
  return '' + years + ' yrs ' + monthDiff + ' mos'
}

export function differenceHours (startTS, endTS) {
  var end = moment(endTS)
  var start = moment(startTS)
  var duration = moment.duration(start.diff(end))
  const hours = duration.asHours()
  return roundedToFixed(hours, 1)
}

export function parseDate (dateStr) {
  if (dateStr) {
    var date = moment(dateStr, 'ddd D MMM')
    return date.toDate()
  }
  return null
}
export function parseDateTime (dateStr) {
  if (dateStr) {
    var date = moment(dateStr, 'ddd D MMM HH:mm')
    return date.toDate()
  }
  return null
}
export function parseDatetoTS (dateStr) {
  if (dateStr) {
    var date = moment(dateStr, 'ddd D MMM HH:mm')
    return date.toDate().getTime()
  }
  return 0
}

export function getTimeslotsBetween (start, end) {
  var startTime = moment(start, 'HH:mm')
  var endTime = moment(end, 'HH:mm')
  endTime = endTime.add(-1, 'h')
  const timeslots = []
  while (startTime <= endTime) {
    timeslots.push({ startTime: timeFormat(startTime.toDate()) })
    startTime = startTime.add(30, 'm')
  }
  return timeslots
}

export function datesBetween (start, end) {
  var dateArray = []
  var currentDate = moment(start)
  var stopDate = moment(end)
  while (currentDate <= stopDate) {
    dateArray.push(moment(currentDate).toDate())
    currentDate = moment(currentDate).add(1, 'days')
  }
  return dateArray
}

export function getWC (date) {
  var wc = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0)
  if (wc.getDay() !== 1) {
    if (wc.getDay() === 0) {
      wc.setDate(wc.getDate() - 6)
    } else {
      wc.setDate(wc.getDate() - wc.getDay() + 1)
    }
  }
  return wc
}

export function getWE (date) {
  var we = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59)
  if (we.getDay() !== 0) {
    we.setDate(we.getDate() - we.getDay() + 7)
  }
  return we
}

export function dayFormat (timestamp) {
  if (timestamp) {
    return moment.utc(timestamp).local().format('ddd')
  } else {
    return ''
  }
}
export function datetimeFormat (timestamp) {
  if (timestamp) {
    return moment.utc(timestamp).local().format('Do MMM HH:mm')
  } else {
    return ''
  }
}
export function dateTimeArrayFormat (dateStr) {
  if (dateStr) {
    var datetime = moment(dateStr, 'ddd D MMM HH:mm')
    const formatdt = datetime.format('YYYY, M, D, H, m')
    return `[${formatdt}]`
  } else {
    return ''
  }
}
export function dateFormat (timestamp) {
  if (timestamp) {
    return moment.utc(timestamp).local().format('DD/MM/YY')
  } else {
    return ''
  }
}
export function dateDisplayFormat (timestamp) {
  if (timestamp) {
    return moment.utc(timestamp).local().format('Do MMMM YYYY')
  } else {
    return ''
  }
}
export function dateShortDisplayFormat (timestamp) {
  if (timestamp) {
    return moment.utc(timestamp).local().format('DD MMM')
  } else {
    return ''
  }
}
export function dateExtFormat (timestamp) {
  if (timestamp) {
    return moment.utc(timestamp).local().format('ddd D MMM')
  } else {
    return ''
  }
}
export function dateYearFormat (timestamp) {
  if (timestamp) {
    return moment(timestamp).format('DD MMM YYYY')
  } else {
    return ''
  }
}
export function timeFormat (timestamp) {
  if (timestamp) {
    return moment.utc(timestamp).local().format('HH:mm')
  } else {
    return ''
  }
}
